import '../Sass/App.scss';
import * as React from 'react'
import { ProgramGroup } from './ProgramGroup';
import { useDrop } from 'react-dnd';

export function Program (props) {

    const CARD_HEIGHT = props.cardWidth * 1.4

    const [{ isOver }, dropRef] = useDrop({
        accept: ['dev-card','ml-card','viral-card'],
        drop: (item) => {
            const dragIndex = item.indexInSeries
            item.sendHandler(dragIndex, 1)
            addProgramGroup(item.cardData, item.sendHandler(dragIndex, 1))
        },
        collect: (monitor) => ({
            isOver: monitor.isOver()
        })
    })

    function addProgramGroup(card, modifiedPrograms) {
        const programs = modifiedPrograms ? modifiedPrograms : props.programs
        const rebuiltProgramGroups = [
            ...programs[props.programIndex],
            [card]
        ]
        const rebuiltPrograms = [
            ...programs.slice(0,props.programIndex),
            rebuiltProgramGroups,
            ...programs.slice(props.programIndex+1,programs.length),
        ]
        props.setCards(rebuiltPrograms)
    }

    function getContent() {
        if (props.program.length > 0) {
            return { header: 'Create new group', subheader: 'Drag cards here to create a new group under your program' }
        } else {
            return { header: 'Develop your program!', subheader: 'Drag cards here to add them to your program.' }
        }
    }

    return (
        <div className='gameboard-program' style={{minHeight: CARD_HEIGHT + 25 }}>
            { props.program.length > 0 ? 
                ( props.program.map((group, index) => 
                    <ProgramGroup key={index} currentHome={props.currentHome} programs={props.programs} programIndex={props.programIndex} groupIndex={index} codebase={props.codebaseInfo} cards={group} cardWidth={props.cardWidth} clickHandler={props.clickHandler} setCards={props.setCards} /> 
                    )
                ) 
            : null }
            <div className='hand-empty' style={{height: props.cardWidth * 1.4 - 40, width: props.cardWidth - 40, padding: 20, fontSize: props.cardWidth / 12 }} ref={dropRef}>
                <p><b>{ getContent().header }</b></p><p className='green-code'>{ getContent().subheader }</p>
            </div> 
        </div>         
    )

}